module.exports = __webpack_public_path__ + "static/media/PZ Microapp - Terms of Use.98d4b8b8.pdf";